// src/utils/token.js

const ACCESS_TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const PERMISSIONS_KEY = 'user_permissions'
const USERNAME_KEY = 'user_name'
const LOGOUT_SYNC_KEY = 'logout_sync'

// token於storage相關操作
export function setAccessToken(token) {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function setRefreshToken(token) {
  localStorage.setItem(REFRESH_TOKEN_KEY, token)
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

// 權限於storage相關操作
export function setStoredPermissions(permissions) {
  localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions || {}))
}

export function getStoredPermissions() {
  const raw = localStorage.getItem(PERMISSIONS_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch (e) {
    console.warn('Failed to parse permissions from localStorage', e)
    return null
  }
}

export function setStoredUsername(name) {
  localStorage.setItem(USERNAME_KEY, name || '')
}

export function getStoredUsername() {
  return localStorage.getItem(USERNAME_KEY) || ''
}

export function clearStoredPermissions() {
  localStorage.removeItem(PERMISSIONS_KEY)
}


export function clearTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
  localStorage.removeItem(PERMISSIONS_KEY)
  localStorage.removeItem(USERNAME_KEY)
  // 因應儲存session功能，登出時讓其他分頁也一併燈出
  localStorage.setItem(LOGOUT_SYNC_KEY, String(Date.now()))
}
